import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { SubmitHandler } from 'react-hook-form';
import toast from 'react-hot-toast';

import { apiPaths } from '../../../../../service/apiPaths';
import ApiService from '../../../../../service/ApiService';
import { IAddTaskSheet, ITaskSheet } from '../../Tasksheet.props';

const useEditTaskSheet = (taskSheetId: string, setMethod: () => void) => {
  const today = new Date().toISOString()?.split("T")[0] || '';

  const [formData, setFormData] = useState<IAddTaskSheet>({
    description: "",
    priority: "low",
    dueDate: today,
    status: "todo",
    query: "",
    backLog: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [taskSheet, setTaskSheet] = useState<ITaskSheet | null>(null);
  const [defaultPriority, setDefaultPriority] = useState<string>("low");
  const [defaultStatus, setDefaultStatus] = useState<string>("todo");

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getAllEmpTaskSheets}?taskId=${taskSheetId}`,
      });
      setTaskSheet(response.data[0]);
      populateFormData(response.data[0]);
    } catch (error) {
      toast.error(`Error - ${error}`, {
        duration: 5000,
      });
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const populateFormData = (taskSheetData: ITaskSheet | any) => {
    setFormData({
      description: taskSheetData?.description,
      priority: taskSheetData?.priority,
      dueDate: taskSheetData?.dueDate,
      status: taskSheetData?.status,
      query: taskSheetData?.query,
      backLog: taskSheetData?.backLog,
    });
    setDefaultPriority(taskSheetData.priority);
    setDefaultStatus(taskSheetData.status);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit: SubmitHandler<IAddTaskSheet> = async () => {
    const data = {
      description: formData.description,
      priority: defaultPriority,
      dueDate: formData.dueDate,
      status: defaultStatus,
      query: formData.query,
      backLog: formData.backLog,
    };
    try {
      const response = await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updateEmpTaskSheet}${taskSheetId}`,
        data: data,
      });
      if (response !== "undefined") {
        toast.success("TaskSheet updated successfully", {
          duration: 5000,
        });
        setTimeout(() => {
          setMethod();
        }, 1500);
      }
    } catch (error) {
      toast.error(`Error - ${error}`, {
        duration: 5000,
      });
      console.error("Error updating taskSheet:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    formData,
    taskSheet,
    handleChange,
    handleSubmit,
    setDefaultPriority,
    defaultPriority,
    defaultStatus,
    setDefaultStatus,
  };
};
export default useEditTaskSheet;
